import Overview from "../components/home/DashboardCards";

function ShowInformation() {
  return (
    <>
      <Overview />
    </>
  );
}

export default ShowInformation;
